/* eslint-disable no-unused-vars */

import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import React, { FC, memo } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { useNavigate } from 'react-router';
import { AlternatingColorTableRow, LoaderBar } from 'src/components';
import { useEmailer } from 'src/hooks/email/useEmailer';
import { EmailerListItem } from 'src/redux/slices/emailer';
import { FixMeLaterApi } from 'src/types';

const EmailerListTable: FC = () => {
  const navigate = useNavigate();
  const { emailerList, meta, isLoading, setFilters } = useEmailer();

  return (
    <>
      <LoaderBar isLoading={isLoading} />
      <Card>
        <PerfectScrollbar>
          <Box minWidth={1050}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Email Subject</TableCell>
                  <TableCell>Open Rate</TableCell>
                  <TableCell>Created At</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {emailerList.map((emailer: EmailerListItem, ind) => (
                  <AlternatingColorTableRow
                    onClick={() => navigate(`/app/emailer/${emailer.id}`)}
                    hover
                    key={ind}
                    style={{ cursor: 'pointer' }}
                  >
                    <TableCell>{emailer?.title ?? ''}</TableCell>
                    <TableCell>{emailer?.open_rate ?? ''}</TableCell>
                    <TableCell>{emailer?.created_at ?? ''}</TableCell>
                  </AlternatingColorTableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
      </Card>
      <Box display="flex" justifyContent="flex-end" p={2}>
        <Pagination
          count={meta?.last_page || 1}
          page={meta?.current_page || 1}
          onChange={(_, p) => setFilters({ page: p })}
        />
      </Box>
    </>
  );
};
export default memo(EmailerListTable);
